import { useEffect, useState } from 'react';
import { useModal } from './ModalProvider';
import { useToast } from './Toast';
import FaceAttendanceModal from './FaceAttendanceModal';

// Popup nhắc CHẤM CÔNG RA cuối giờ (server đẩy notify type:'att-checkout' lúc 17:00 / 17:30 OP).
// Hiện đè lên mọi màn, kèm nút mở thẳng màn chấm công khuôn mặt.
export default function AttendanceCheckoutPopup() {
  const { openModal, closeModal } = useModal();
  const toast = useToast();
  const [msg, setMsg] = useState(null); // { title, body } | null

  useEffect(() => {
    const onNotify = (e) => {
      const d = e.detail || {};
      if (d.type === 'att-checkout') setMsg({ title: d.title || 'Đến giờ chấm công ra', body: d.body || '' });
    };
    window.addEventListener('ft:notify', onNotify);
    return () => window.removeEventListener('ft:notify', onNotify);
  }, []);

  if (!msg) return null;
  const openFace = () => { setMsg(null); openModal(<FaceAttendanceModal onClose={closeModal} toast={toast} />); };

  return (
    <div className="att-popup-mask" onClick={() => setMsg(null)}>
      <div className="att-popup" onClick={(e) => e.stopPropagation()}>
        <div className="att-popup-ico"><i className="ti ti-camera-check" /></div>
        <h3 className="att-popup-title">{msg.title}</h3>
        <p className="att-popup-body">{msg.body}</p>
        <div className="att-popup-btns">
          <button className="btn ghost" onClick={() => setMsg(null)}>Để sau</button>
          <button className="btn" onClick={openFace}><i className="ti ti-face-id" /> Chấm công ngay</button>
        </div>
      </div>
    </div>
  );
}
